var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 760,
    viewBox: "0 0 1920 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 760,
    fill: "#EC7405"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-170.881 0L-704 953H-203.119L330 0H-170.881Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1752.22 0L1315 761H1725.78L2163 0H1752.22Z",
    fill: "#0099DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoBg3);
export default __webpack_public_path__ + "static/media/promo-bg-3.adaa121b606bc514eec0dd9f37068a58.svg";
export { ForwardRef as ReactComponent };